import { Mode, ModeWithoutReadOnly, Type } from "../Form"
import { BaseElement } from "../BaseElement";
import { uniqueID } from "../../../../util";

type Options = {
  question?: string,
  options?: {
    label: string,
    value: string,
    selected: boolean,
  }[],
  renderId?: string,
  required?: boolean,
  type: Type,
};

export class Selection extends BaseElement {
  required: boolean;
  private _question: string;
  private _options: {
    label: string,
    value: string,
    selected: boolean,
  }[];
  questionErrorMessage = '';
  answerErrorMessage = '';

  constructor(options_: Options) {
    const { question, options, renderId, required, type } = options_;
    super(type, renderId);
    this._question = question ?? '';
    this._options = options ?? [{label: '', value: uniqueID()+'', selected: false}];
    this.required = required ?? false;
  }

  validateField(mode: Mode): boolean {
    let errorMessage = '';
    if (mode === Mode.EDIT) {
      const valid = !!this._question;
      if (!valid) {
        errorMessage = 'required';
      }
      this.questionErrorMessage = errorMessage;
      return valid;
    } else if (mode === Mode.FORM) {
      const valid = (this.required && this._options.filter(x => x.selected).length > 0) || !this.required;
      if (!valid) {
        errorMessage = 'required';
      }
      this.answerErrorMessage = errorMessage;
      return valid;
    } else {
      return true;
    }
  }

  public get options() {
    return this._options;
  }

  public set options(options: {
    label: string,
    value: string,
    selected: boolean,
  }[]) {
    this.answerErrorMessage = '';
    this._options = options;
  }

  public get question() {
    return this._question;
  }

  public set question(question: string) {
    this.questionErrorMessage = '';
    this._question = question;
  }

  getForDB(mode: ModeWithoutReadOnly) {
    const result = {
      type: this.type,
      renderId: this.renderId,
      required: this.required,
      question: this.question,
      options: this.options,
    };

    if (mode === Mode.EDIT) {
      result.options = result.options.map(option => ({...option, selected: false}));
    } 

    return result;
  }
}